import { request } from 'util/request';

async function addStock(body: any) {
  return request('inventory/levels', body, 'PATCH');
}

export { addStock }
